import { render, staticRenderFns } from "./ItemListRealBuyLayout.vue?vue&type=template&id=8fffe8d8&scoped=true"
import script from "./ItemListRealBuyLayout.vue?vue&type=script&lang=js"
export * from "./ItemListRealBuyLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fffe8d8",
  null
  
)

export default component.exports